import { SETTLE_TASK_IDS } from "@/shared/constants/taskIds";

export type SettleStepStatus = "active" | "complete" | "waiting" | "upcoming" | "locked";

export interface SettleStepDef {
  id: string;
  section: 1 | 2 | 3;
  taskId?: string;
  getTitle: (firstName: string) => string;
  getExpandDescription?: (firstName: string) => string;
}

export interface SettleSection {
  key: 1 | 2 | 3;
  title: string;
  getDescription: (firstName: string) => string;
}

export const SETTLE_SECTIONS: SettleSection[] = [
  {
    key: 1,
    title: "Set up the estate's bank account",
    getDescription: () =>
      "Get a tax ID and a bank account in the estate's name, so bills and payments run through the estate",
  },
  {
    key: 2,
    title: "Move the assets",
    getDescription: (firstName) =>
      `Each step uses the assets and debts already on ${firstName}'s estate record`,
  },
  {
    key: 3,
    title: "Wrap up the estate",
    getDescription: () => "Once the money has moved and the records are complete",
  },
];

export const SETTLE_STEPS: SettleStepDef[] = [
  {
    id: "get-ein",
    section: 1,
    taskId: SETTLE_TASK_IDS.GET_EIN,
    getTitle: () => "Get the estate's tax ID (EIN)",
  },
  {
    id: "open-bank",
    section: 1,
    taskId: SETTLE_TASK_IDS.OPEN_BANK,
    getTitle: () => "Open the estate bank account",
  },
  {
    id: "connect-bank",
    section: 1,
    taskId: SETTLE_TASK_IDS.CONNECT_BANK,
    getTitle: () => "Connect the account to Elayne",
  },
  {
    id: "release-accounts",
    section: 2,
    getTitle: (firstName) => `Move ${firstName}'s money into the estate account`,
    getExpandDescription: (firstName) =>
      `Banks and companies holding ${firstName}'s money won't release it until you tell them where it goes. Each one has its own forms, so we do this step with you, 1 account at a time.`,
  },
  {
    id: "pay-self",
    section: 2,
    getTitle: () => "Pay yourself back for estate costs",
  },
  {
    id: "pay-debts",
    section: 2,
    getTitle: (firstName) => `Pay ${firstName}'s debts and the estate's bills`,
    getExpandDescription: () =>
      "Debts are paid from the estate account, not your own pocket, unless you co-signed or shared the account",
  },
  {
    id: "file-taxes",
    section: 2,
    getTitle: (firstName) =>
      `File ${firstName}'s final tax return and the estate's tax return`,
    getExpandDescription: () =>
      "The estate may need its own tax return if it earned income after the date of death",
  },
  {
    id: "distribute",
    section: 2,
    getTitle: () => "Give each person what they inherit",
    getExpandDescription: () =>
      "Once the debts and taxes are paid, what's left goes to the people named in the will, or to family by state law when there isn't a will",
  },
  {
    id: "final-accounting",
    section: 3,
    getTitle: () => "Hand over the final accounting",
    getExpandDescription: () =>
      "Each payment and deposit since the estate account opened, with receipts attached, ready to download for the court and the people receiving what's left",
  },
];

export const TOTAL_STEPS = SETTLE_STEPS.length;
